import React from 'react';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
    Row,
    RightComponents,
    LeftComponents,
    Grid,
    GridColumn,
} from '../../components/Layout';
import {
    Button,
    SearchBox,
    TextBox,
    DataForm,
} from '../../components/Form';
import {
    TableData,
    TableHeader,
    TableBody,
    TableRow,
    TableColumn,
} from '../../components/Table';
import {
    MobileInfoBox,
    Title,
    TextView,
    Picture,
    PanelBox,
    Modal,
} from '../../components/Display';
import TaroffShopsEdit from '../shops/TaroffShopsEdit';
import TaroffShopsNew from '../shops/TaroffShopsNew';
import TaroffShopsDelete from '../shops/TaroffShopsDelete';
import { API_URL, postData } from '../../Api';

export default function TaroffShops(props) {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [modal, setModal] = useState(null);
    const allProps = { ...props, ...Object.fromEntries(searchParams.entries()) };
    const [generatedToken, setGeneratedToken] = useState(null);
    const [showTokenModal, setShowTokenModal] = useState(false);
    const [showGenerateModal, setShowGenerateModal] = useState(false);
    const [tokenIpAddress, setTokenIpAddress] = useState('');
    const [selectedShopId, setSelectedShopId] = useState(null);
    const [copySuccess, setCopySuccess] = useState(false);

    // Post sending modal states
    const [showPostModal, setShowPostModal] = useState(false);
    const [postModalStage, setPostModalStage] = useState('confirm'); // 'confirm', 'loading', 'success', 'error'
    const [postModalData, setPostModalData] = useState(null);
    const [postModalError, setPostModalError] = useState(null);
    const handleCreateNewShop = () => {
        setModal(
            Modal({
                children: <TaroffShopsNew onDismiss={() => setModal(null)} />,
                onDismiss: () => setModal(null),
            })
        );
    };
    const handleSearch = () => {
        applyFilters();
    };
    const buttonExcelClick = () => {
        const queryString = { 'token': localStorage.getItem('admin_auth_token') };
        filterQId && (queryString['q-id'] = filterQId);
        filterQTitle && (queryString['q-title'] = filterQTitle);
        filterQGatewayKey && (queryString['q-gateway-key'] = filterQGatewayKey);
        filterQMobile && (queryString['q-mobile'] = filterQMobile);
        filterQPhone && (queryString['q-phone'] = filterQPhone);
        filterQHasOpenTickets && (queryString['q-has-open-tickets'] = '1');
        const url =
            API_URL +
            '/api/panel/page/taroff-shops/export-excel?' +
            new URLSearchParams(queryString).toString();
        window.open(url, '_blank');
    };
    const toggleOpenTickets = () => {
        const next = !filterQHasOpenTickets;
        setFilterQHasOpenTickets(next);
        const newSearchParams = { ...Object.fromEntries(searchParams.entries()) };
        if (next) newSearchParams['q-has-open-tickets'] = '1'; else delete newSearchParams['q-has-open-tickets'];
        delete newSearchParams['page'];
        navigate({ search: '?' + new URLSearchParams(newSearchParams).toString() });
    };
    const [tableData, setTableData] = useState({});
    const [tableSize, setTableSize] = useState(parseInt(allProps['size']) || 20);
    const [tablePage, setTablePage] = useState(parseInt(allProps['page']) || 1);
    const gotoPage = (page, size = undefined) => {
        setTableData({});
        setTablePage(page);
        size && setTableSize(size);
        setSearchParams({ ...searchParams, page: page, size: size || tableSize });
    };
    const clearFilters = () => {
        setFilterQId('');
        setFilterQTitle('');
        setFilterQGatewayKey('');
        // setFilterQGatewayKeyOld('');
        // setFilterQGatewayKeyNew('');
        setFilterQMobile('');
        setFilterQPhone('');
        setFilterQHasOpenTickets(false);
        setSearchParams({});
    };
    const applyFilters = () => {
        const newSearchParams = {};
        filterQId && (newSearchParams['q-id'] = filterQId);
        filterQTitle && (newSearchParams['q-title'] = filterQTitle);
        filterQGatewayKey && (newSearchParams['q-gateway-key'] = filterQGatewayKey);
        // filterQGatewayKeyOld && (newSearchParams['q-gateway-key-old'] = filterQGatewayKeyOld);
        // filterQGatewayKeyNew && (newSearchParams['q-gateway-key-new'] = filterQGatewayKeyNew);
        filterQMobile && (newSearchParams['q-mobile'] = filterQMobile);
        filterQPhone && (newSearchParams['q-phone'] = filterQPhone);
        filterQHasOpenTickets && (newSearchParams['q-has-open-tickets'] = '1');
        navigate({ search: '?' + new URLSearchParams(newSearchParams).toString() });
    };
    const [filterQId, setFilterQId] = useState(allProps['q-id'] || '');
    const [filterQTitle, setFilterQTitle] = useState(allProps['q-title'] || '');
    const [filterQGatewayKey, setFilterQGatewayKey] = useState(allProps['q-gateway-key'] || '');
    // const [filterQGatewayKeyOld, setFilterQGatewayKeyOld] = useState(
    //     allProps['q-gateway-key-old'] || ''
    // );
    // const [filterQGatewayKeyNew, setFilterQGatewayKeyNew] = useState(
    //     allProps['q-gateway-key-new'] || ''
    // );
    const [filterQMobile, setFilterQMobile] = useState(allProps['q-mobile'] || '');
    const [filterQPhone, setFilterQPhone] = useState(allProps['q-phone'] || '');
    const [filterQHasOpenTickets, setFilterQHasOpenTickets] = useState(!!allProps['q-has-open-tickets']);
    useEffect(() => {
        postData('/api/panel/page/taroff-shops/table-data', {
            size: tableSize,
            page: tablePage,
            q_id: filterQId,
            q_title: filterQTitle,
            q_gateway_key: filterQGatewayKey,
            // q_gateway_key_old: filterQGatewayKeyOld,
            // q_gateway_key_new: filterQGatewayKeyNew,
            q_mobile: filterQMobile,
            q_phone: filterQPhone,
            q_has_open_tickets: filterQHasOpenTickets ? '1' : '',
        }).then((response) => {
            setTableData(response.data);
        });
    }, [searchParams, modal, props]);
    const buttonUpdateClick = (row) => {
        setPostModalData(row);
        setPostModalStage('confirm');
        setPostModalError(null);
        setShowPostModal(true);
    };

    const handleConfirmSendToPost = async () => {
        setPostModalStage('loading');

        try {
            const response = await postData('/api/panel/page/taroff-shops/update-shop', {
                id: postModalData.param_id,
            });

            if (response.data.ok) {
                setPostModalStage('success');
            } else {
                setPostModalError(response.data.error || 'خطایی رخ داده است');
                setPostModalStage('error');
            }
        } catch (error) {
            setPostModalError(error?.error || error?.detail || error?.message || 'خطا در ارسال درخواست');
            setPostModalStage('error');
        }
    };

    const handleClosePostModal = () => {
        setShowPostModal(false);
        setPostModalStage('confirm');
        setPostModalData(null);
        setPostModalError(null);
        // Refresh table data if successful
        if (postModalStage === 'success') {
            setSearchParams({ ...searchParams });
        }
    };
    const handleViewShop = (row) => {};
    const handleEditShop = (row) => {
        setModal(
            Modal({
                children: <TaroffShopsEdit id={row.param_id} onDismiss={() => setModal(null)} />,
                onDismiss: () => setModal(null),
            })
        );
    };
    const handleDeleteShop = (row) => {
        setModal(
            Modal({
                children: (
                    <TaroffShopsDelete id={row.param_id_2} onDismiss={() => setModal(null)} />
                ),
                onDismiss: () => setModal(null),
            })
        );
    };
    
    const handleOpenGenerateToken = (row) => {
        setSelectedShopId(row.param_id);
        setTokenIpAddress('');
        setShowGenerateModal(true);
    };
    
    const handleGenerateToken = async () => {
        const response = await postData('/api/panel/page/taroff-shops-edit/generate-token', {
            shop_id: parseInt(selectedShopId),
            title: 'API Access Token',
            ip_address: tokenIpAddress || null
        });
        
        if (response.status === 'success') {
            setGeneratedToken(response.token);
            setShowGenerateModal(false);
            setShowTokenModal(true);
            setTokenIpAddress('');
            setCopySuccess(false);
        } else {
            alert('Error generating token: ' + (response.message || 'Unknown error'));
        }
    };
    
    const handleCopyToken = async () => {
        if (generatedToken) {
            try {
                await navigator.clipboard.writeText(generatedToken);
                setCopySuccess(true);
                setTimeout(() => setCopySuccess(false), 2000);
            } catch (err) {
                console.error('Failed to copy token:', err);
                alert('خطا در کپی کردن توکن. لطفاً به صورت دستی کپی کنید.');
            }
        }
    };
    return (
        <PanelBox>
            <Row>
                <RightComponents>
                    <Title>مدیریت فروشگاه ها</Title>
                </RightComponents>
                <LeftComponents>
                    <Button onClick={handleCreateNewShop} color={'secondary'} rightIcon={'far fa-plus'}>
                        ایجاد فروشگاه
                    </Button>
                    <Button onClick={handleSearch} color={'secondary'} rightIcon={'far fa-search'}>
                        جستجو
                    </Button>
                </LeftComponents>
            </Row>
            <RightComponents wrap={true}>
                <SearchBox onEnter={applyFilters}
                    label={'شناسه'}
                    value={filterQId}
                    onChange={setFilterQId}
                    width={'60px'}
                />
                <SearchBox onEnter={applyFilters}
                    label={'عنوان'}
                    value={filterQTitle}
                    onChange={setFilterQTitle}
                    width={'120px'}
                />
                <SearchBox onEnter={applyFilters}
                    label={'کلید گیت وی'}
                    value={filterQGatewayKey}
                    onChange={setFilterQGatewayKey}
                    width={'120px'}
                />
                {/* <SearchBox onEnter={applyFilters}
                    label={'گیت وی قدیمی'}
                    value={filterQGatewayKeyOld}
                    onChange={setFilterQGatewayKeyOld}
                    width={'100px'}
                />
                <SearchBox onEnter={applyFilters}
                    label={'گیت وی جدید'}
                    value={filterQGatewayKeyNew}
                    onChange={setFilterQGatewayKeyNew}
                    width={'100px'}
                /> */}
                <SearchBox onEnter={applyFilters}
                    label={'همراه'}
                    value={filterQMobile}
                    onChange={setFilterQMobile}
                    width={'100px'}
                />
                <SearchBox onEnter={applyFilters}
                    label={'تلفن'}
                    value={filterQPhone}
                    onChange={setFilterQPhone}
                    width={'100px'}
                />
                <Button
                    rightIcon={'far fa-headset'}
                    color={filterQHasOpenTickets ? 'accent' : undefined}
                    onClick={toggleOpenTickets}
                >
                    دارای تیکت باز
                </Button>
                <Button rightIcon={'far fa-search'} onClick={applyFilters}>
                    جستجو
                </Button>
                <Button rightIcon={'far fa-trash'} onClick={clearFilters}>
                    پاک کردن
                </Button>
            </RightComponents>
            <TableData total={tableData.total} size={tableSize} page={tablePage} setPage={gotoPage}>
                <TableHeader>
                    <TableRow>
                        <TableColumn mobile={true}>mobile</TableColumn>
                        <TableColumn mobile={false}>شناسه - عنوان</TableColumn>
                        <TableColumn mobile={false}>لوگو</TableColumn>
                        <TableColumn mobile={false}>کلید گیت وی</TableColumn>
                        <TableColumn mobile={false}>مالی</TableColumn>
                        <TableColumn mobile={false}>آدرس فروشگاه</TableColumn>
                        <TableColumn mobile={false}> </TableColumn>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {tableData.rows?.map((row, index) => (
                        <TableRow key={index}>
                            <TableColumn mobile={true}>
                                <MobileInfoBox />
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <RightComponents>
                                    <TextView bold={true}>{row.text_id}</TextView>
                                    <TextView>{row.text}</TextView>
                                    <TextView bold={true}>{row.text_title}</TextView>
                                </RightComponents>
                                {row.text_open_tickets > 0 && (
                                    <span className="inline-flex items-center gap-1 mt-1 rounded-full bg-red-50 text-red-700 border border-red-200 px-2 py-0.5 text-xs font-medium dark:bg-red-950 dark:text-red-300 dark:border-red-800">
                                        <i className="far fa-headset"></i>
                                        {Number(row.text_open_tickets).toLocaleString('fa-IR')} تیکت باز
                                    </span>
                                )}
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <Picture />
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <RightComponents>
                                    <TextView>{row.text_2}</TextView>
                                    <TextView bold={true}>{row.text_gateway_id}</TextView>
                                </RightComponents>
                                <RightComponents>
                                    <TextView>{row.text_3}</TextView>
                                    <TextView bold={true}>{row.text_gateway_key_new}</TextView>
                                </RightComponents>
                                <RightComponents>
                                    <TextView>{row.text_4}</TextView>
                                    <TextView bold={true}>{row.text_gateway_key_old}</TextView>
                                </RightComponents>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <RightComponents>
                                    <TextView>{row.text_5}</TextView>
                                    <TextView bold={true} format={'money'}>
                                        {row.text_taroff_const_share}
                                    </TextView>
                                </RightComponents>
                                <RightComponents>
                                    <TextView>{row.text_6}</TextView>
                                    <TextView bold={true}>{row.text_taroff_share_percent}</TextView>
                                </RightComponents>
                                <RightComponents>
                                    <TextView>{row.text_7}</TextView>
                                    <TextView bold={true} format={'money'}>
                                        {row.text_service_price}
                                    </TextView>
                                </RightComponents>
                                <RightComponents>
                                    <TextView>{row.text_8}</TextView>
                                    <TextView bold={true} format={'money'}>
                                        {row.text_post_const_price}
                                    </TextView>
                                </RightComponents>
                                <RightComponents>
                                    <TextView>{row.text_9}</TextView>
                                    <TextView bold={true} format={'money'}>
                                        {row.text_peik_price}
                                    </TextView>
                                    <TextView>{row.text_peik_delivery_price}</TextView>
                                </RightComponents>
                                <RightComponents>
                                    <TextView>{row.text_10}</TextView>
                                    <TextView bold={true}>{row.text_pre_pay_percent}</TextView>
                                </RightComponents>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <RightComponents>
                                    <TextView>{row.text_city_id_province_id_title}</TextView>
                                    <TextView>{row.text_11}</TextView>
                                    <TextView>{row.text_city_id_title}</TextView>
                                </RightComponents>
                                <TextView>{row.text_address}</TextView>
                                <RightComponents>
                                    <TextView>{row.text_12}</TextView>
                                    <TextView>{row.text_post_code}</TextView>
                                    <TextView>{row.text_13}</TextView>
                                    <TextView>{row.text_mobile}</TextView>
                                    <TextView>{row.text_14}</TextView>
                                    <TextView>{row.text_phone}</TextView>
                                </RightComponents>
                                <TextView>{row.text_gateway_state}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <LeftComponents>
                                    <Button
                                        onClick={() => buttonUpdateClick(row)}
                                        color={'accent'}
                                        rightIcon={'far fa-check'}
                                        tooltip={'ارسال به پست'}
                                    ></Button>
                                    <Button
                                        onClick={() => handleOpenGenerateToken(row)}
                                        color={'accent'}
                                        rightIcon={'far fa-key'}
                                        tooltip={'تولید توکن'}
                                    ></Button>
                                    <Button
                                        onClick={() => handleViewShop(row)}
                                        color={'accent'}
                                        rightIcon={'far fa-info'}
                                        tooltip={'مشاهده'}
                                    ></Button>
                                    <Button
                                        onClick={() => handleEditShop(row)}
                                        color={'accent'}
                                        rightIcon={'far fa-edit'}
                                        tooltip={'ویرایش'}
                                    ></Button>
                                    <Button
                                        onClick={() => handleDeleteShop(row)}
                                        color={'warn'}
                                        rightIcon={'far fa-trash'}
                                        tooltip={'حذف'}
                                    ></Button>
                                </LeftComponents>
                            </TableColumn>
                        </TableRow>
                    ))}
                </TableBody>
            </TableData>
            {modal && modal}
            {showGenerateModal && (
                Modal({
                    children: (
                        <PanelBox>
                            <DataForm>
                                <Title>تولید توکن دسترسی</Title>
                                <Grid>
                                    <GridColumn width={12}>
                                        <TextBox
                                            label={'آدرس IP (اختیاری)'}
                                            value={tokenIpAddress}
                                            onChange={setTokenIpAddress}
                                            placeholder="برای محدود کردن دسترسی به IP خاص"
                                        />
                                        <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
                                            در صورت خالی گذاشتن، توکن از هر IP قابل استفاده خواهد بود
                                        </p>
                                    </GridColumn>
                                </Grid>
                                <LeftComponents>
                                    <Button onClick={() => setShowGenerateModal(false)}>انصراف</Button>
                                    <Button onClick={handleGenerateToken}>تولید توکن</Button>
                                </LeftComponents>
                            </DataForm>
                        </PanelBox>
                    ),
                    onDismiss: () => setShowGenerateModal(false),
                })
            )}
            {showTokenModal && (
                Modal({
                    children: (
                        <PanelBox>
                            <DataForm>
                                <Title>توکن دسترسی جدید</Title>
                                <p className="mb-4 text-gray-600 dark:text-gray-400">
                                    توکن دسترسی جدید برای این فروشگاه با موفقیت ایجاد شد.
                                </p>
                                <Grid>
                                    <GridColumn width={12}>
                                        <div className="bg-gray-100 dark:bg-gray-800 p-4 rounded mb-4">
                                            <code className="break-all select-all text-sm font-mono dark:text-gray-300">
                                                {generatedToken}
                                            </code>
                                        </div>
                                        <p className="text-sm text-red-600 dark:text-red-400">
                                            توجه: این توکن را در جای امنی ذخیره کنید. پس از بستن این پنجره، امکان مشاهده مجدد آن وجود ندارد.
                                        </p>
                                    </GridColumn>
                                </Grid>
                                <LeftComponents>
                                    <Button onClick={() => {
                                        setShowTokenModal(false);
                                        setCopySuccess(false);
                                    }}>بستن</Button>
                                    <Button onClick={handleCopyToken}>
                                        {copySuccess ? 'کپی شد!' : 'کپی به کلیپ‌بورد'}
                                    </Button>
                                </LeftComponents>
                            </DataForm>
                        </PanelBox>
                    ),
                    onDismiss: () => {
                        setShowTokenModal(false);
                        setCopySuccess(false);
                    },
                })
            )}
            {showPostModal && (
                Modal({
                    children: (
                        <PanelBox>
                            <DataForm>
                                {postModalStage === 'confirm' && (
                                    <>
                                        <Title>تایید ارسال به پست</Title>
                                        <Grid>
                                            <GridColumn width={12}>
                                                <div className="mb-4">
                                                    <p className="text-gray-700 dark:text-gray-300 mb-2">
                                                        آیا از ارسال فروشگاه زیر به پست اطمینان دارید؟
                                                    </p>
                                                    {postModalData && (
                                                        <div className="bg-gray-100 dark:bg-gray-800 p-4 rounded">
                                                            <p className="mb-2">
                                                                <span className="font-bold">شناسه: </span>
                                                                {postModalData.text_id}
                                                            </p>
                                                            <p className="mb-2">
                                                                <span className="font-bold">عنوان: </span>
                                                                {postModalData.text_title}
                                                            </p>
                                                            <p>
                                                                <span className="font-bold">کلید گیت‌وی: </span>
                                                                {postModalData.text_gateway_key_new || postModalData.text_gateway_key_old || '-'}
                                                            </p>
                                                        </div>
                                                    )}
                                                </div>
                                            </GridColumn>
                                        </Grid>
                                        <LeftComponents>
                                            <Button
                                                onClick={handleClosePostModal}
                                                color="secondary"
                                            >
                                                انصراف
                                            </Button>
                                            <Button
                                                onClick={handleConfirmSendToPost}
                                                color="primary"
                                                rightIcon="far fa-check"
                                            >
                                                تایید و ارسال
                                            </Button>
                                        </LeftComponents>
                                    </>
                                )}

                                {postModalStage === 'loading' && (
                                    <>
                                        <Title>در حال ارسال به پست</Title>
                                        <Grid>
                                            <GridColumn width={12}>
                                                <div className="flex flex-col items-center justify-center py-8">
                                                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mb-4"></div>
                                                    <p className="text-gray-600 dark:text-gray-400">
                                                        لطفاً صبر کنید، درخواست در حال ارسال است...
                                                    </p>
                                                </div>
                                            </GridColumn>
                                        </Grid>
                                    </>
                                )}

                                {postModalStage === 'success' && (
                                    <>
                                        <Title>ارسال موفق</Title>
                                        <Grid>
                                            <GridColumn width={12}>
                                                <div className="flex flex-col items-center justify-center py-8">
                                                    <div className="rounded-full bg-green-100 dark:bg-green-900 p-3 mb-4">
                                                        <i className="far fa-check-circle text-green-600 dark:text-green-400 text-4xl"></i>
                                                    </div>
                                                    <p className="text-green-700 dark:text-green-400 font-bold mb-2">
                                                        ثبت انجام شد
                                                    </p>
                                                    <p className="text-gray-600 dark:text-gray-400 text-center">
                                                        فروشگاه با موفقیت به پست ارسال شد.
                                                    </p>
                                                </div>
                                            </GridColumn>
                                        </Grid>
                                        <LeftComponents>
                                            <Button
                                                onClick={handleClosePostModal}
                                                color="primary"
                                            >
                                                بستن
                                            </Button>
                                        </LeftComponents>
                                    </>
                                )}

                                {postModalStage === 'error' && (
                                    <>
                                        <Title>خطا در ارسال</Title>
                                        <Grid>
                                            <GridColumn width={12}>
                                                <div className="flex flex-col items-center justify-center py-8">
                                                    <div className="rounded-full bg-red-100 dark:bg-red-900 p-3 mb-4">
                                                        <i className="far fa-times-circle text-red-600 dark:text-red-400 text-4xl"></i>
                                                    </div>
                                                    <p className="text-red-700 dark:text-red-400 font-bold mb-2">
                                                        خطا در ثبت
                                                    </p>
                                                    <p className="text-gray-600 dark:text-gray-400 text-center mb-2 break-words select-text">
                                                        {postModalError || 'خطایی در ارسال درخواست رخ داده است'}
                                                    </p>
                                                </div>
                                            </GridColumn>
                                        </Grid>
                                        <LeftComponents>
                                            <Button
                                                onClick={handleClosePostModal}
                                                color="secondary"
                                            >
                                                بستن
                                            </Button>
                                            <Button
                                                onClick={handleConfirmSendToPost}
                                                color="primary"
                                                rightIcon="far fa-redo"
                                            >
                                                تلاش مجدد
                                            </Button>
                                        </LeftComponents>
                                    </>
                                )}
                            </DataForm>
                        </PanelBox>
                    ),
                    onDismiss: () => {
                        if (postModalStage !== 'loading') {
                            handleClosePostModal();
                        }
                    },
                })
            )}
        </PanelBox>
    );
}
